import { useEffect, useState } from "react";
import { http } from "../lib/api";
import { money } from "../lib/casePath";
import { MapaRiesgo } from "../components/riesgo/MapaRiesgo";
import { Portafolio } from "../components/riesgo/Portafolio";
import { EwsKpis } from "../components/ews/EwsKpis";

export default function RiesgoPortafolio() {
  const [d, setD] = useState(null);
  useEffect(() => { http.get("/riesgo/portafolio/completo").then((r) => setD(r.data)); }, []);
  const k = d?.cartera_kpi;
  return (
    <main className="mx-auto max-w-7xl space-y-8 px-4 py-8 sm:px-6 lg:px-10" data-testid="portafolio-page" style={{ animation: "rise .35s ease-out both" }}>
      <div><p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8C867A]">Directores · Administradores · Master Admin</p>
        <h1 className="font-serif-display text-4xl font-bold sm:text-5xl">Riesgo de portafolio<span className="text-[#E8643C]">.</span></h1>
        <p className="mt-2 text-sm text-[#5C5850]">También disponible en Reportes como plantillas «Mapa de riesgo», «Concentración» y «Reservas de cartera».</p></div>
      {k && <div className="grid grid-cols-2 gap-3 sm:grid-cols-5" data-testid="portafolio-kpis">{[["Saldo de cartera", money(k.saldo)], ["Cartera vencida (≥ 90 d)", money(k.vencido)], ["IMOR propio", `${(k.imor * 100).toFixed(2)}%`],
        ["Reservas", money(d.reservas)], ["Créditos · con atraso", `${k.creditos} · ${k.con_atraso}`]].map(([l, v]) => (
        <div key={l} className="rounded-2xl border border-[#E2DDD5] bg-white p-4"><p className="text-[10px] font-semibold uppercase tracking-widest text-[#8C867A]">{l}</p><p className="font-serif-display text-2xl font-bold" data-testid={`pf-${l.split(" ")[0].toLowerCase()}`}>{v}</p></div>))}</div>}
      <EwsKpis testid="portafolio-ews" />
      <MapaRiesgo />
      <Portafolio />
    </main>
  );
}
